import gql from 'graphql-tag';

export const GENERATE_MODULE = gql`
  mutation GenerateSections($input: GenerateModuleInput!) {
    generateSections(input: $input) {
      sections {
        section {
          _id
          title
          content {
            html
          }
        }
        highlights {
          _id
          term
          slug
          definition {
            html
            text
          }
        }

        quizz {
          _id
          name
          type
          responses {
            isRight
            key
            response
          }
        }
      }
    }
  }
`;
